import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost } from 'api'
import AuthContext from 'context/auth-context'

// Interprets a natural-language description of a desired View into a target section + filters,
// without creating anything. Backed by POST /ai_view_interpretations.
const createInterpretation = async (token, params) => {
  const url = 'ai_view_interpretations'
  const objectName = 'ai_view_interpretation'
  const data = await apiPost({ url, token, objectName, params })
  return data
}

export function useInterpretView({ options = {} } = {}) {
  const token = useContext(AuthContext)

  return useMutation(
    ({ query, sectionId }) => createInterpretation(token, { query, section_id: sectionId }),
    { ...options }
  )
}
